// extracted by mini-css-extract-plugin
module.exports = {"recentPostsContainer":"FrontPagePosts_recentPostsContainer__1ny0e","recentPostsTitle":"FrontPagePosts_recentPostsTitle__15YWT"};